import { iConfig } from '@/config/config-models';

export const config: iConfig = {
	apiBaseUrl: 'https://backend.cobalt.care/',
	providerManagementFeature: false,
	downForMaintenance: false,

	gaTrackingId: undefined,
	ga4MeasurementId: undefined,
	mixPanelId: 'a9d06ee96f13418a14786e29be149c28',

	showDebug: false,

	localhostSubdomain: undefined,

	authRedirectUrls: [],
	storageKeys: {
		mhicRecentOrdersStorageKey: 'mhicRecentOrders',
		chunkloadRefreshKey: 'ChunkLoadError-refresh',
	},
};

export default config;
